import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UserInfo, UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() sectionName: string | undefined = '';
  @Input() isHrTransparent: boolean | undefined = false;

  titulo = 'Hola, ';
  usuario = 'Guest';
  private readonly addVehicleKey = 'vehicle.add_vehicle';
  private userSubscription!: Subscription;
  backButton = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {

    const path = window.location.pathname;
    const addVehicleUrl = path.split('/').pop();

    this.userSubscription = this.userService.getUserInfo().subscribe((userInfo: UserInfo | null) => {
      if (userInfo) {
        this.usuario = userInfo.name ?? 'Guest';
      } else {
        this.usuario = 'Guest';
      }
    });

    this.route.data.subscribe((data) => {
      const titleKey = data['titleKey'] as string | undefined;
      const resolvedTitle = data['title'] as string | undefined;

      if (titleKey || resolvedTitle) {
        if (titleKey === 'homeTitle') {
          this.sectionName = `${this.translate.instant('hello')}, ${this.usuario}`;
        } else if (addVehicleUrl === 'add-vehicle') {
          this.sectionName = this.addVehicleKey;
        } else {
          this.sectionName = titleKey ?? resolvedTitle;
        }
      }

      if (data['backArrow']) {
        this.backButton = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

  backButtonAction(): void {
    window.history.back();
  }
}
